import { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from '../error/ErrorPage';
import { NavMarker } from 'react-rhumb';
import Raven from 'raven-js';
// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-objects-ui-compo... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const UNAUTHORIZED = 'UNAUTHORIZED';
const NO_DATA = 'NO_DATA';
const SERVER_ERROR = 'SERVER_ERROR';
const ProfileErrorsMap = {
  [UNAUTHORIZED]: {
    errorCode: '403',
    navMarkerName: 'NO_PERMISSIONS'
  },
  [NO_DATA]: {
    errorCode: '404',
    navMarkerName: 'OBJECT_NOT_FOUND'
  },
  [SERVER_ERROR]: {
    errorCode: '500',
    navMarkerName: 'PERMISSIONS_FETCH_ERROR'
  }
};
const getErrorType = (data, error) => {
  if ((!data || !data.crmObject) && !error) {
    return NO_DATA;
  }
  if (error) {
    const {
      graphQLErrors
    } = error;
    if (graphQLErrors) {
      const hasAuthException = graphQLErrors.some(gqlError => gqlError.extensions && gqlError.extensions.ERROR_CODE === UNAUTHORIZED || gqlError.message.match(/AuthorizationException/));
      if (hasAuthException) {
        return UNAUTHORIZED;
      }
    }
  }
  return SERVER_ERROR;
};
const ProfilePermissionsContainerError = ({
  result
}) => {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'error' does not exist on type '{ data?: ... Remove this comment to see the full error message
  const {
    error,
    data
  } = result;
  const errorType = getErrorType(data, error);
  useEffect(() => {
    if (errorType === SERVER_ERROR) {
      console.warn('[ProfilePermissionContainer] An unknown response was received from the GraphQL service. The app may be in an unstable state.');
      Raven.captureException(error);
    }
  }, [error, errorType]);
  const {
    errorCode,
    navMarkerName
  } = ProfileErrorsMap[errorType];
  return /*#__PURE__*/_jsx(ErrorPage, {
    "data-test-id": `profile-permissions-container-error-${errorCode}`,
    errorCode: errorCode,
    RhumbMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName
    })
  });
};
ProfilePermissionsContainerError.propTypes = {
  result: PropTypes.shape({
    data: PropTypes.object,
    error: PropTypes.object
  }),
  objectType: AnyCrmObjectTypePropType
};
export default ProfilePermissionsContainerError;